export class SecondhandSensor {
  mac?: string;
  startDate?: string;
  endDate?: string;

  constructor(params?: Partial<SecondhandSensor>) {
    Object.assign(this, params);
  }
}